import { Reducer } from 'redux';
import { SummaryState } from './types';
import { StudentActionTypes } from '../types';
import { IMessage } from 'types';
import { Status, VisaStatus } from '../core/types';

const initialState: SummaryState = {
  intakeId: '',
  offerId: '',
  regionConfigId: '',
  withAgent: false,
  country: '',
  courseFee: 0,
  courseName: '',
  depositPaid: false,
  dob: '',
  email: '',
  givenName: '',
  surname: '',
  nationality: '',
  age: 0,
  countryOfVisaApplication: '',
  startDate: '',
  uni: '',
  isAgent: '',
  agentName: '',
  cas_status: Status.PRE_DEPOSIT,
  casStatusUpdatedAt: 0,
  studentDetailsComplete: 0,
  historyComplete: 0,
  financeComplete: 0,
  consentsComplete: 0,
  studentDetailsRequired: 0,
  historyRequired: 0,
  financeRequired: 0,
  consentsRequired: 0,
  totalPagesRequired: 0,
  totalPagesCompleted: 0,
  totalPercentageComplete: '',
  docsUploaded: 0,
  docsTotal: 0,
  finDocsUploaded: 0,
  finDocsTotal: 0,
  followUpDocsUploaded: 0,
  followUpDocsTotal: 0,
  beforeTravelDocsComplete: 0,
  beforeTravelDocsRequired: 0,
  afterArrivalDocsComplete: 0,
  afterArrivalDocsRequired: 0,
  newDocsUploaded: false,
  newFinDocsUploaded: false,
  isNewDocuments: false,
  isNewMessage: false,
  lastTouch: 0,
  fundsMatured: [{ type: 'INFO', value: 'N/A' }],
  visaStatus: VisaStatus.NONE,
  updated_at: 0,
  unreadMessagesStudent: 0,
  unreadMessagesUni: 0,
  unreadMessagesUniToAgent: 0,
  unreadMessagesStudentToAgent: 0,
  unreadMessagesAgentToUni: 0,
  unreadMessagesUniSecure: 0,
  newMessage: false,
  unreadMessagesStudentSecure: 0,
  agentAccess: '',
  isStudentDetailsComplete: false,
  isHistoryComplete: false,
  isFinanceComplete: false,
  isConsentsComplete: false,
  isDocsComplete: false,
  isFinDocsComplete: false,
  isPreCASComplete: false,
  isDepositComplete: false,
  isFinanceSponsorsValid: false,
  isTasksComplete: false,
  tasksCompleteAt: 0,
  calendlyInterviews: [],
  recordedInterviews: [],
  agentDocsUploaded: 0,
  agentDocsTotal: 0,
  dependants: {}
};

const reducer: Reducer<SummaryState> = (state: SummaryState = initialState, action: any) => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS: {
      return { ...action.payload.student.summary };
    }
    case StudentActionTypes.NEW_MESSAGE: {
      const message: IMessage = action.payload;
      let unreadMessagesStudent = state.unreadMessagesStudent;
      let unreadMessagesAgentToStudent = state.unreadMessagesAgentToStudent;
      let unreadMessagesStudentSecure = state.unreadMessagesStudentSecure;

      switch (message.messageType) {
        case 'note':
          if (message.messageFrom === 'uni' && message.messageTo === 'student' && message.isSendToStudent) {
            unreadMessagesStudent += 1;
          }
          break;
        case 'secure':
          if (message.messageFrom === 'uni' && message.messageTo === 'student' && message.isSendToStudent) {
            unreadMessagesStudentSecure += 1;
          }
          break;
        case 'agentStudent':
          if (
            (message.messageFrom === 'agent' || message.messageFrom === 'enroly') &&
            message.messageTo === 'student' &&
            message.isSendToStudent
          ) {
            unreadMessagesAgentToStudent += 1;
          }
          break;
        default:
          break;
      }
      return {
        ...state,
        unreadMessagesStudent,
        unreadMessagesAgentToStudent,
        unreadMessagesStudentSecure
      };
    }
    case StudentActionTypes.UPDATE_SUMMARY: {
      if (action.payload?.summary) {
        return {
          ...state,
          ...action.payload.summary
        };
      }
      return state;
    }
    default:
      return state;
  }
};

export { reducer as SummaryReducer };
